/* Figma: Status Badge 2161:5034 / 5047 / 5099 — 77x28, radius 80, px 12 py 4 */
.badge {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 77px;
  height: 28px;
  padding: 4px 12px;
  border-radius: var(--radius-pill);
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: var(--letter-spacing);
  white-space: nowrap;
}

/* The High/Medium fills are a solid colour at 10% opacity in Figma, drawn as a
   separate rectangle behind the label — reproduced with a ::before so the text
   keeps full contrast instead of inheriting the opacity. */
.badge::before {
  content: '';
  position: absolute;
  inset: 0;
}

.high { color: var(--badge-high-text); }
.high::before { background: var(--badge-high-bg); opacity: 0.1; }

.medium { color: var(--badge-med-text); }
.medium::before { background: var(--badge-med-bg); opacity: 0.1; }

.low { color: var(--badge-low-text); }
.low::before { background: var(--badge-low-bg); }

.label { position: relative; }
